export const TextColorVariableNames = {
  'wst-heading-1-color': 'wst-heading-1-color',
  'wst-heading-2-color': 'wst-heading-2-color',
  'wst-heading-3-color': 'wst-heading-3-color',
  'wst-heading-4-color': 'wst-heading-4-color',
  'wst-heading-5-color': 'wst-heading-5-color',
  'wst-heading-6-color': 'wst-heading-6-color',
  'wst-paragraph-1-color': 'wst-paragraph-1-color',
  'wst-paragraph-2-color': 'wst-paragraph-2-color',
  'wst-paragraph-3-color': 'wst-paragraph-3-color'
};
export const TextVariableNames = {
  ...TextColorVariableNames,
  'wst-heading-1-font': 'wst-heading-1-font',
  'wst-heading-2-font': 'wst-heading-2-font',
  'wst-heading-3-font': 'wst-heading-3-font',
  'wst-heading-4-font': 'wst-heading-4-font',
  'wst-heading-5-font': 'wst-heading-5-font',
  'wst-heading-6-font': 'wst-heading-6-font',
  'wst-paragraph-1-font': 'wst-paragraph-1-font',
  'wst-paragraph-2-font': 'wst-paragraph-2-font',
  'wst-paragraph-3-font': 'wst-paragraph-3-font'
};
//# sourceMappingURL=text.js.map